import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    if (localStorage.getItem('token')) {
      const duplicate = request.clone({ params: request.params.set('api_token', localStorage.getItem('token')) });
      return next.handle(duplicate).pipe(tap((evt: HttpEvent<any>) => {
      }, ((error: HttpErrorResponse) => {
        if (error instanceof HttpErrorResponse) {
          if (error.status == 401) {
            localStorage.removeItem('token');
            localStorage.removeItem('profile');
            localStorage.removeItem('missionaryGAUId');
            localStorage.removeItem('isMissionaryUser');
            localStorage.removeItem('isHQUser');
            localStorage.removeItem('isGAUEditor');
            localStorage.removeItem('isFinanceUser');
            localStorage.removeItem('session');
            localStorage.removeItem('loginProvider');
            localStorage.removeItem('userId');
            localStorage.removeItem('selectedAccount');            
            var sourceApp = localStorage.getItem('sourceApp');
            localStorage.clear();
            localStorage.setItem('sourceApp',sourceApp);
            window.location.pathname = '/';
          } else {
          }
        }
      })));
    } else {
      return next.handle(request).pipe(tap((evt: HttpEvent<any>) => {
      }, ((error: any) => {
      })));
    }
  }
}
